import { render, staticRenderFns } from "./Mypagetop.vue?vue&type=template&id=ef112f62&"
import script from "./Mypagetop.vue?vue&type=script&lang=ts&"
export * from "./Mypagetop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports